export enum SignPosType {
  DESIGN_LOCATION = 'DESIGN_LOCATION',
  FREE_LOCATION = 'FREE_LOCATION',
}
